// Advertisement
export const GET_ADVERTISEMENTS_SUCCESS = 'GET_ADVERTISEMENTS_SUCCESS';
export const GET_ADVERTISEMENT_SUCCESS = 'GET_ADVERTISEMENT_SUCCESS';
export const POST_ADVERTISEMENT_SUCCESS = 'POST_ADVERTISEMENT_SUCCESS';
export const DELETE_ADVERTISEMENT_SUCCESS = 'DELETE_ADVERTISEMENT_SUCCESS';
export const VIEW_ADVERTISEMENT_SUCCESS = 'VIEW_ADVERTISEMENT_SUCCESS';
export const CHANGE_ADVERTISEMENT_MODE = 'CHANGE_ADVERTISEMENT_MODE';

// Device Type
export const GET_DEVICE_TYPES_SUCCESS = 'GET_DEVICE_TYPES_SUCCESS';
export const CHANGE_CAMPAIGN_MODE = 'CHANGE_CAMPAIGN_MODE';
// User

// Template
export const GET_TEMPLATES_SUCCESS = 'GET_TEMPLATES_SUCCESS';

// Error Handling
export const SEND_MESSAGE = 'SEND_MESSAGE';
export const SEND_SNACKBAR_CLEAR = 'SEND_SNACKBAR_CLEAR';

// Progress bar
export const SET_PROGRESS = 'SET_PROGRESS';

// Alert Popup
export const SHOW_POPUP_CONFIRMATION = 'SHOW_POPUP_CONFIRMATION';
export const HANDLE_POPUP_CONFIRMATION = 'HANDLE_POPUP_CONFIRMATION';
export const RESET_POPUP_CONFIRMATION = 'RESET_POPUP_CONFIRMATION';

export const GET_DASHBOARD_DATA = 'GET_DASHBOARD_DATA';
